import React, { Fragment } from 'react'
import { Field } from 'formular'

import Text from 'components/_new/typography/Text/Text'
import { Box } from 'components/_new/layout'

import Group from './Group/Group'

import messages from './messages'


type TagsProps = {
  likesField: Field<Review.LikeTag[]>
  dislikesField: Field<Review.LikeTag[]>
  likes: Review.LikeTag[]
  dislikes: Review.LikeTag[]
}

const LikeTags: React.FunctionComponent<TagsProps> = ({ likesField, dislikesField, likes, dislikes }) => {
  return (
    <Fragment>
      <Text size="18-24" semibold message={messages.title} />
      <Box mt={16}>
        <Group
          field={likesField}
          emoji="👍"
          title={messages.likes}
          items={likes}
        />
      </Box>
      <Box mt={24}>
        <Group
          field={dislikesField}
          emoji="👎"
          title={messages.dislikes}
          items={dislikes}
        />
      </Box>
    </Fragment>
  )
}

export default LikeTags
